import SUGalleriesShortcodes from './shortcodes/galleries'
import SUPlayersShortcodes from './shortcodes/players'
import SUOtherShortcodes from './shortcodes/other'
import SUImageCarouselShortcode from './shortcodes/image-carousel'
import SUTooltipShortcode from './shortcodes/tooltip'
import SUContentSliderShortcode from './shortcodes/content-slider'
import SUExitPopupShortcode from './shortcodes/exit-popup'
import SUsShortcodes from './shortcodes/s'
import SUPostsGridShortcode from './shortcodes/posts-grid'
import SUPricingTableShortcode from './shortcodes/pricing-table'
import SUProgressBarShortcode from './shortcodes/progress-bar'
import SUProgressPieShortcode from './shortcodes/progress-pie'
import SUSplashScreenShortcode from './shortcodes/splash-screen'
import SUCountdownShortcode from './shortcodes/countdown'

SUGalleriesShortcodes()
SUPlayersShortcodes()
SUOtherShortcodes()
SUImageCarouselShortcode()
SUTooltipShortcode()

SUContentSliderShortcode()
SUExitPopupShortcode()
SUsShortcodes()
SUPostsGridShortcode()
SUPricingTableShortcode()
SUProgressBarShortcode()
SUProgressPieShortcode()
SUSplashScreenShortcode()
SUCountdownShortcode()
